import { LegacyDocumentButton } from 'components/common-form/sidePanel/docToolbar/documents-legacy';
import { DocumentType } from 'models/documents/DocumentType';
import { connect } from 'react-redux';
import { getAvailableDocuments } from 'state/selectors';
import { AppState } from 'state/state.model';
import { QuoteWorkspaceType } from 'state/workspaces/model';

interface StateProps {
  documents: DocumentType[];
}
interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}
interface Props extends StateProps, OwnProps {}

const mapStateToProps = (state: AppState, { workspaceType, tabId }: OwnProps): StateProps => {
  const documents = getAvailableDocuments(state, workspaceType, tabId);
  return { documents };
};

function DocumentButtonsLegacy({ documents, tabId, workspaceType }: Props) {
  return documents.map(doc => (
    <LegacyDocumentButton documentType={doc} tabId={tabId} workspaceType={workspaceType} key={doc} />
  ));
}

export const ConnectedDocumentButtonsLegacy = connect(mapStateToProps)(DocumentButtonsLegacy);
